import { RelatedCard } from '@ridango/core';
import { RelatedCardPartialStoreState, RELATED_CARD_STATE_KEY } from './related-card.reducer';

export const getLoaded = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].loaded;

export const getBlockingFinished = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].isBlockingFinished;
export const getUnBlockingFinished = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].isUnBlockingFinished;

export const getError = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].error;

export const getIsActionCompleted = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].isActionCompleted;

export const getAllRelatedCards = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].allIds.map((id) => {
        return state[RELATED_CARD_STATE_KEY].allNormalized[id];
    });

export const getAllDiscountGroups = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].allDiscountGroups;

export const getSelectedDiscountGroup = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].selectedDiscountGroup;

export const getTypeEmailCards = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].typeEmailIds.map((id) => {
        return state[RELATED_CARD_STATE_KEY].allNormalized[id];
    });

export const getTypeTravelcardCards = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].typeTravelcardIds.map((id) => {
        return state[RELATED_CARD_STATE_KEY].allNormalized[id];
    });

export const getTypePresonalCodeCards = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].typePersonalCodeIds.map((id) => {
        return state[RELATED_CARD_STATE_KEY].allNormalized[id];
    });

export const getSelectedRelatedCard = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].allNormalized[state[RELATED_CARD_STATE_KEY].selectedId];

export const getSelectedRelatedCardIsBlocked = (state: RelatedCardPartialStoreState) =>
    Boolean(state[RELATED_CARD_STATE_KEY].allNormalized[state[RELATED_CARD_STATE_KEY].selectedId]?.blocked);

export const getSelectedRelatedCardUserActions = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].selectedCardUserActions;

export const getSelectedRelatedCardEditMode = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].editMode;

export const getCardStatus = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].cardStatus;

export const getSeutulippuStatus = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].seutulippu.isCompleted;

export const getSeutulippuLoading = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].seutulippu.loading;

export const getSeutulippuError = (state: RelatedCardPartialStoreState) =>
    state[RELATED_CARD_STATE_KEY].seutulippu.error;

export const getSelectedCardsIds = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].selectedIds;

export const getSortField = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].sortField;

export const getSortDirection = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].sortDirection;

export const getAllNormalized = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].allNormalized;

export const getAllIds = (state: RelatedCardPartialStoreState) => state[RELATED_CARD_STATE_KEY].allIds;
